import { render, staticRenderFns } from "./transfer-apply-list.vue?vue&type=template&id=66f500f2&"
import script from "./transfer-apply-list.vue?vue&type=script&lang=js&"
export * from "./transfer-apply-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports